import isNumber from 'lodash-es/isNumber'
import isEmpty from 'lodash-es/isEmpty'
import isBoolean from 'lodash-es/isBoolean'
import isNaN from 'lodash-es/isNaN'
import Cookies from 'js-cookie'
import { APM, APM_LOWERCASE, WISE } from '../common/constant'
import qs from 'qs'
import { logger } from './log'

export const isDevEnv = process.env.NODE_ENV !== 'production'

export function getPlansMap(planList = [], key = 'plan_code') {
  if (!planList.length) {
    return null
  }

  return planList.reduce((pre, item) => {
    const mapKey = item[key]

    return {
      ...pre,
      ...(mapKey ? { [mapKey]: { ...item } } : {})
    }
  }, {})
}

export const getLang = Cookies.get('_zm_lang') || 'en-US'

export const isEmptyVal = (value) => {
  if (value instanceof Date || isBoolean(value)) {
    return false
  }

  return isNumber(value) ? isNaN(value) : isEmpty(value)
}

export const safeJSONParse = (jsonString, defaultValue = null) => {
  let json = defaultValue
  try {
    json = JSON.parse(jsonString)
  } catch (e) {
    logger.error(e)
  }
  return json
}

export const getWisePaymentName = (imageFileName) => {
  const wiseSubstr = `${WISE}-`
  return imageFileName.substring(imageFileName.indexOf(wiseSubstr) + wiseSubstr.length).toLowerCase()
}

export const apmPaymentType = (paymentMethodName = '', imageFileName) => {
  if (paymentMethodName === WISE) {
    const wisePaymentName = getWisePaymentName(imageFileName)
    return `${APM_LOWERCASE}-${wisePaymentName}`
  }
  return `${APM_LOWERCASE}-${paymentMethodName}`
}

export const getQueryByLocationSearch = () => {
  const searchString = location.search?.replace(/^\?/g, '') || ''
  return qs.parse(searchString) || {}
}

export const getApmGaTrackingName = (paymentMethodName, imageFileName) => {
  if (paymentMethodName === WISE) {
    return imageFileName.replace(WISE, APM).toLowerCase()
  }
  return `${APM}-${paymentMethodName}`.toLowerCase()
}

export const parseNumber = (value) => {
  const onlyNumbers = value.replace(/\D/g, '')
  return parseInt(onlyNumbers, 10)
}
